/* —— Kirmen Mobile Menu Accordion - Safe Stable Version —— */
(function () {
  var MQ = '(max-width: 991px)';
  var TRANSITION_MS = 260;

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function getPanel(btn) {
    if (!btn) return null;

    var item = btn.closest('.kr-mm__item');
    if (!item) return null;

    return item.querySelector(':scope > .kr-mm__panel');
  }

  function forceReflow(el) {
    return el.offsetHeight;
  }

  function openPanel(btn, panel) {
    if (!panel) return;

    btn.setAttribute('aria-expanded', 'true');

    panel.hidden = false;
    panel.classList.remove('is-open', 'is-closing');
    panel.classList.add('is-opening');

    panel.style.overflow = 'hidden';
    panel.style.maxHeight = '0px';

    forceReflow(panel);

    panel.style.maxHeight = panel.scrollHeight + 'px';

    requestAnimationFrame(function () {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });

    setTimeout(function () {
      if (btn.getAttribute('aria-expanded') !== 'true') return;

      panel.classList.remove('is-opening');
      panel.classList.add('is-open');
      panel.style.maxHeight = '';
      panel.style.overflow = '';
    }, TRANSITION_MS + 40);
  }

  function closePanel(btn, panel) {
    if (!panel) return;

    btn.setAttribute('aria-expanded', 'false');

    panel.classList.remove('is-open', 'is-opening');
    panel.classList.add('is-closing');

    panel.hidden = false;
    panel.style.overflow = 'hidden';
    panel.style.maxHeight = panel.scrollHeight + 'px';

    forceReflow(panel);

    requestAnimationFrame(function () {
      panel.style.maxHeight = '0px';
    });

    setTimeout(function () {
      if (btn.getAttribute('aria-expanded') !== 'false') return;

      panel.classList.remove('is-closing');
      panel.hidden = true;
      panel.style.maxHeight = '';
      panel.style.overflow = '';
    }, TRANSITION_MS + 40);
  }

  function closeSiblingPanels(btn) {
    var currentItem = btn.closest('.kr-mm__item');
    var currentTier = currentItem ? currentItem.parentElement : null;

    if (!currentTier) return;

    currentTier.querySelectorAll(':scope > .kr-mm__item > .kr-mm__link[aria-expanded="true"], :scope > .kr-mm__item > .kr-mm__row > .kr-mm__toggle[aria-expanded="true"]').forEach(function (otherBtn) {
      if (otherBtn === btn) return;

      var otherPanel = getPanel(otherBtn);
      closePanel(otherBtn, otherPanel);
    });
  }

  function handleClick(e) {
    if (!isMobile()) return;

    var menu = e.target.closest('.kr-mm');
    if (!menu) return;

    /*
      Important:
      Stop the click from being treated as an outside drawer click.
      Do NOT prevent default unless it is an accordion button.
      This keeps normal menu links clickable.
    */
    e.stopPropagation();

    var btn =
      e.target.closest('.kr-mm__toggle') ||
      e.target.closest('.kr-mm__link--top[type="button"]') ||
      e.target.closest('.kr-mm__link--mid[type="button"]');

    if (!btn || !menu.contains(btn)) return;

    e.preventDefault();

    var panel = getPanel(btn);
    if (!panel) return;

    var isOpen = btn.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closePanel(btn, panel);
    } else {
      closeSiblingPanels(btn);
      openPanel(btn, panel);
    }
  }

  function resetDesktop() {
    document.querySelectorAll('.kr-mm__panel').forEach(function (panel) {
      panel.classList.remove('is-open', 'is-opening', 'is-closing');
      panel.style.maxHeight = '';
      panel.style.overflow = '';
      panel.hidden = true;
    });

    document.querySelectorAll('.kr-mm [aria-expanded]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function refreshMobileOpenPanels() {
    document.querySelectorAll('.kr-mm [aria-expanded="true"]').forEach(function (btn) {
      var panel = getPanel(btn);
      if (!panel) return;

      panel.hidden = false;
      panel.classList.add('is-open');
      panel.classList.remove('is-opening', 'is-closing');
      panel.style.maxHeight = '';
      panel.style.overflow = '';
    });
  }

  function handleResize() {
    if (!isMobile()) {
      resetDesktop();
    } else {
      refreshMobileOpenPanels();
    }
  }

  document.addEventListener('click', handleClick, true);

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(handleResize, 100);
  });
})();